module.exports = {
  lineArr: [
    {
      label: 'changchun',
      val: '长春',
      top: '82',
      right: '80',
      id: 4893
    },
    {
      label: 'shenyang',
      val: '沈阳',
      top: '183',
      right: '139',
      id: 4895
    },
    {
      label: 'qinhuangdao',
      val: '秦皇岛',
      top: '217',
      right: '205',
      id: 4896
    },
    {
      label: 'xiongan',
      val: '雄安',
      top: '270',
      right: '334',
      id: 4897
    },
    {
      label: 'handan',
      val: '邯郸',
      top: '346',
      right: '376',
      id: 4898
    },
    {
      label: 'xiaolangdi',
      val: '小浪底',
      top: '414',
      right: '396',
      id: 4899
    },
    {
      label: 'xiangyang',
      val: '襄阳',
      top: '484',
      right: '416',
      id: 4900
    },
    {
      label: 'sanxia',
      val: '三峡',
      top: '540',
      right: '450',
      id: 4901
    },
    {
      label: 'zhangjiajie',
      val: '张家界',
      top: '584',
      right: '528',
      id: 4902
    },
    {
      label: 'tongren',
      val: '铜仁',
      top: '640',
      right: '504',
      id: 4903
    },
    {
      label: 'tianyan',
      val: '天眼',
      top: '685',
      right: '592',
      id: 4904
    },
    {
      label: 'guilin',
      val: '桂林',
      top: '765',
      right: '514',
      id: 4906
    },
    {
      label: 'fengshanxian',
      val: '凤山县',
      top: '724',
      right: '542',
      id: 4905
    },
    {
      label: 'guiyang',
      val: '贵阳',
      top: '638',
      right: '568',
      id: 4917
    },
    {
      label: 'liuzhou',
      val: '柳州',
      top: '730',
      right: '454',
      id: 4916
    },
    {
      label: 'hezhou',
      val: '贺州',
      top: '742',
      right: '376',
      id: 4915
    },
    {
      label: 'shenzhen',
      val: '深圳',
      top: '784',
      right: '304',
      id: 4914
    },
    {
      label: 'zhangzhou',
      val: '漳州',
      top: '710',
      right: '188',
      id: 4913
    },
    {
      label: 'quanzhou',
      val: '泉州',
      top: '680',
      right: '150',
      id: 4912
    },
    {
      label: 'fuding',
      val: '福鼎',
      top: '642',
      right: '132',
      id: 4911
    },
    {
      label: 'ningbo',
      val: '宁波',
      top: '528',
      right: '70',
      id: 4910
    },
    {
      label: 'jiading',
      val: '嘉定',
      top: '482',
      right: '70',
      id: 4909
    },
    {
      label: 'lianyungang',
      val: '连云港',
      top: '390',
      right: '130',
      id: 4908
    },
    {
      label: 'qingdao',
      val: '青岛',
      top: '316',
      right: '98',
      id: 4907
    }
  ]
}
